<template>
  <button
    class="w-10 h-10 flex items-center justify-center border border-googlegray rounded cursor-pointer hover:bg-gray-05 transition-colors"
    :disabled="isAppleLoading"
    :aria-label="$t('login_continue_with_apple')"
    @click="loginWithApple"
  >
    <img :src="AppleIcon" width="18" height="18" alt="Apple" />
  </button>
</template>

<script setup lang="ts">
import AppleIcon from '@/assets/icons/apple-brand.svg?url'
import { useAppleLogin } from '@/composables/useAppleLogin'
import { useLoginSdkInit } from '@/composables/useLoginSdkInit'

const { loginWithApple, initialize, isAppleLoading } = useAppleLogin()

useLoginSdkInit(initialize)
</script>
